/**
 * Replace known English-only phrases in BlockInfo HTML from BM with the active locale.
 * Add entries here only for stable copy that is not yet localized in SFCC attributes.
 *
 * @param {string | undefined | null} source
 * @param {import('react-intl').IntlShape} intl
 * @returns {string | undefined | null}
 */
export function applyKnownBlockInfoTranslations(source, intl) {
  if (source == null || typeof source !== 'string' || intl == null) {
    return source;
  }

  const howToCushion = intl.formatMessage({
    defaultMessage: 'How to choose your right cushion',
    id: 'customize_panel.block_info.how_to_choose_right_cushion',
  });

  return source.replace(/\bHow to choose your right cushion\b/gi, howToCushion);
}

/**
 * Wraps block info markup: text lives in `<div class="content">`, tooltip in a sibling
 * `<div role="option-tooltip">`. Layout is styled under stepDescriptionBody (grid + gap).
 *
 * If BM already sends `<div class="content">…</div>` before the tooltip, we do not wrap again.
 *
 * @param {string | undefined | null} source
 * @returns {string | undefined | null}
 */
export function wrapBlockInfoText(source) {
  if (source == null || typeof source !== 'string') {
    return source;
  }

  const trimmed = source.trim();

  if (!trimmed) {
    return source;
  }

  const tooltipRe = /<div\s+[^>]*\brole\s*=\s*(['"])option-tooltip\1[^>]*>/i;
  const match = trimmed.match(tooltipRe);

  const startsWithContentDiv = /^<div\s+[^>]*\bclass\s*=\s*["'][^"']*\bcontent\b/i.test(trimmed);

  if (match && match.index != null) {
    const before = trimmed.slice(0, match.index).trim();
    const after = trimmed.slice(match.index);

    const beforeIsContentWrapped = /^<div\s+[^>]*\bclass\s*=\s*["'][^"']*\bcontent\b/i.test(before);

    if (beforeIsContentWrapped) {
      return `${before}${after}`;
    }

    return `<div class="content">${before}</div>${after}`;
  }

  if (startsWithContentDiv) {
    return trimmed;
  }

  return `<div class="content">${trimmed}</div>`;
}
